import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mantine/core';
import { MdCircle } from 'react-icons/md';
import { match } from 'ts-pattern';
import { colors } from 'components/theme/theme';
import { StyleProps } from 'components';
export const SaveStatusCircle = t0 => {
  const $ = _c(22);
  const {
    className,
    disabled,
    isDirty
  } = t0;
  let T0;
  let color;
  let glow;
  let iconProps;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== disabled || $[2] !== isDirty) {
    const {
      label,
      glow: t4,
      ...t5
    } = {
      size: 8,
      ...(disabled ? {
        label: "",
        color: colors.gray[2],
        glow: false
      } : isDirty ? {
        label: "Saving",
        color: colors.orange[5],
        glow: true
      } : {
        label: "Saved",
        color: colors.green[5],
        glow: true
      })
    };
    glow = t4;
    iconProps = t5;
    ({
      color
    } = iconProps);
    T0 = Tooltip;
    t3 = label;
    t2 = className;
    t1 = label.toLowerCase();
    $[0] = className;
    $[1] = disabled;
    $[2] = isDirty;
    $[3] = T0;
    $[4] = color;
    $[5] = glow;
    $[6] = iconProps;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    T0 = $[3];
    color = $[4];
    glow = $[5];
    iconProps = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
  }
  const t4 = `save-status-${t1}`;
  let t5;
  if ($[10] !== color || $[11] !== glow || $[12] !== iconProps) {
    t5 = glow ? <MdCircle {...iconProps} style={{
      filter: `drop-shadow(0px 0px 2px ${color}) drop-shadow(0px 0px 6px ${color})`
    }} /> : <MdCircle {...iconProps} />;
    $[10] = color;
    $[11] = glow;
    $[12] = iconProps;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t4 || $[16] !== t5) {
    t6 = <div className={t2} data-test-id={t4}>{t5}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t6) {
    t7 = <T0 label={t3}>{t6}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};